import { render, staticRenderFns } from "./relative.vue?vue&type=template&id=fc0d6152&scoped=true"
import script from "./relative.vue?vue&type=script&lang=js"
export * from "./relative.vue?vue&type=script&lang=js"
import style0 from "./relative.vue?vue&type=style&index=0&id=fc0d6152&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0d6152",
  null
  
)

export default component.exports